module.exports = __webpack_public_path__ + "static/brightsparks2-aca3f52302407bb7a9379b89467a8159.jpg";